import { Typography } from '@musinsa/mds';

import type { FC } from 'react';

type TypographyProps = React.ComponentProps<typeof Typography>;

const MdsTypography: FC<TypographyProps> = ({ children, ...props }) => (
  <Typography {...props}>{children}</Typography>
);

export { MdsTypography, type TypographyProps };
